import {useEffect, useContext} from 'react'
import {TablaGraficas} from '../componentes/Home'
import {Noticias, BarraLateral} from '../componentes/Home'
import {useMsal} from '@azure/msal-react'
import {AgregarPaquetesACache, PoblarCacheComun} from '../cache/servicios-cache'
import {ContextoAplicacion} from '../contexto'
import {
  AgregarEmpresasACache,
  AgregarServiciosACache,
} from '../cache/servicios-cache'
import {useState} from 'react'
import {
  ObtenerInformacionCuentaPorEmpresaId,
  FachadaObtenerEjecucionAtencionesOrdenesMesEmpresaId,
} from '../microservicios'
import useValidacionTransaccionPendiente from '../componentes/usuarioContable/ValidacionTransaccionPendiente'
const Home = () => {
  useValidacionTransaccionPendiente()

  const {accounts} = useMsal()

  const contextoAplicacion = useContext(ContextoAplicacion)

  const idEmpresa = contextoAplicacion.infoEmpresa.id ?? 0

  const [datosAtenciones, setdatosAtenciones] = useState({})

  const [saldoDisponible, setSaldoDisponible] = useState({})

  const cachingApp = async () => {
    await Promise.allSettled([
      PoblarCacheComun(),
      AgregarEmpresasACache(),
      AgregarServiciosACache(),
      AgregarPaquetesACache(),
    ])
  }

  useEffect(() => {
    if (!accounts?.[0]) return
    cachingApp()
  }, [accounts])

  useEffect(() => {
    const consultarDatosAtenciones = async () => {
      try {
        const fecha = new Date()
        const res = await FachadaObtenerEjecucionAtencionesOrdenesMesEmpresaId(
          idEmpresa,
          fecha
        )
        if (res.status === 204) {
          return
        }
        setdatosAtenciones(res.data)
      } catch (error) {
        console.log(error)
      }
    }

    const obtenerInformacionCuentaPorEmpresaId = async () => {
      try {
        const res = await ObtenerInformacionCuentaPorEmpresaId(
          contextoAplicacion.infoEmpresa.id
        )
        if (res.status === 204) {
          return
        }
        setSaldoDisponible(res.data)
      } catch (error) {
        console.log(error)
      }
    }
    if (idEmpresa) {
      consultarDatosAtenciones()
      obtenerInformacionCuentaPorEmpresaId()
    }
  }, [idEmpresa])

  return (
    <div className="w-full absolute inset-0 flex flex-wrap justify-center items-end mt-36">
      <BarraLateral
        datosAtenciones={datosAtenciones}
        saldoDisponible={saldoDisponible}
      />
      <div className="w-82% h-auto flex flex-wrap justify-center items-center ">
        <div className="w-full z-40">
          <TablaGraficas nombreEmpresa={'CENCOSUD SUPERMERCADOS'} />
        </div>
        <div className="w-full py-10">
          <Noticias />
        </div>
      </div>
    </div>
  )
}

export default Home
